import type { Organization } from '../types/organization.type';

export const ORGANIZATIONS: ReadonlyArray<Organization> = [
  {
    id: 'sun-intl',
    name: 'Sun International',
    initials: 'SI',
    location: 'Johannesburg, South Africa',
    accountCount: 20,
    memberCount: 48,
    joinedAtIso: '2021-03-01',
  },
  {
    id: 'aurora-collection',
    name: 'Aurora Hotel Collection',
    initials: 'AH',
    location: 'London, United Kingdom',
    accountCount: 9,
    memberCount: 17,
    joinedAtIso: '2023-07-15',
  },
  {
    id: 'meridian-resorts',
    name: 'Meridian Resorts Group',
    initials: 'MR',
    location: 'Dubai, United Arab Emirates',
    accountCount: 12,
    memberCount: 31,
    joinedAtIso: '2024-01-09',
  },
  {
    id: 'coastline-hospitality',
    name: 'Coastline Hospitality',
    initials: 'CH',
    location: 'Cape Town, South Africa',
    accountCount: 4,
    memberCount: 6,
    joinedAtIso: '2025-05-02',
  },
];

export const DEFAULT_PRIMARY_ORGANIZATION_ID = ORGANIZATIONS[0].id;
